/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { IDialogMessage } from 'src/app/@amiga-pyme/components/ami-dialog-message/ami-dialog-message.interface';
import { ISettingsTable } from '../../interfaces/table.interface';
import { CrudService } from '../../services/crud.service';
import { IEventAction } from '../components/ami-table/ami-table.interface';

@Component({
  template: ''
})
export class CrudTemplate {
  @Output() itemSelected = new EventEmitter<boolean>();
  open = {
    create: false,
    update: false
  };
  table: { settings: ISettingsTable; data: any[] } = {
    settings: {
      title: '',
      columns: []
    },
    data: null
  };
  itemToUpdate = {};
  message: IDialogMessage;
  suscriptionBase$: Subscription;

  constructor(
    @Inject(String) private name: string,
    private service: CrudService
  ) {}

  onCloseCreate() {
    this.open.create = false;
  }

  onCloseUpdate() {
    this.open.update = false;
  }

  onReciveAction(event: IEventAction) {
    const data = event?.data as any;
    if (event.action === 'delete') {
      this.deleteItem$(data.id);
    } else if (event.action === 'create') {
      this.open.create = true;
    } else if (event.action === 'update') {
      this.itemToUpdate = data;
      this.open.update = true;
    }
  }

  async deleteItem$(id: number) {
    this.message = { message: `Eliminando ${this.name}` };
    this.message = await this.service.delete(id);
    const status = this.message.status;
    if (200 <= status && status < 300) {
      setTimeout(() => {
        this.service.getData$();
      }, 1000);
    }
  }

  unsubscribeBase() {
    this.suscriptionBase$.unsubscribe();
  }
}
